import React from 'react';
import PdfDownloader from './PdfDownloader';
import './Guides.css';
import { useTranslation } from 'react-i18next';
import img1 from '../../assets/aboutPieria/1.jpg';
import img2 from '../../assets/aboutPieria/2.jpg';
import img3_EN from '../../assets/aboutPieria/3_EN.jpg';
import img3_GR from '../../assets/aboutPieria/3_GR.jpg';
import img4 from '../../assets/aboutPieria/4.jpg';
import img5 from '../../assets/aboutPieria/5.jpg';
import img6 from '../../assets/aboutPieria/6.jpg';
import img7 from '../../assets/aboutPieria/7.jpg';
import img8 from '../../assets/aboutPieria/8.jpg';

const DownloadsPage = () => {

  const { i18n } = useTranslation();
  const selectedLanguage = sessionStorage.getItem('selectedLanguage') || 'en';

    const titles = {
     gr: {
       greek: "Ελληνικα (Greek)",
       english: "Αγγλικα (English)",
     },
     en: {
       greek: "Greek (Ελληνικα)",
       english: "English (Αγγλικα)",
     },
    };


  // DATA: Greek Section
  const greekFiles = [
    {
      id: 1,
      image: img1,
      hoverText: "ΤΟΥΡΙΣΤΙΚΟΣ ΟΔΗΓΟΣ ΠΙΕΡΙΑΣ",
      fileUrl: "/1_EN-GR.pdf",
      fileName: "ΤΟΥΡΙΣΤΙΚΟΣ ΟΔΗΓΟΣ ΠΙΕΡΙΑΣ.pdf"
    },
    {
      id: 2,
      image: img2,
      hoverText: "ΧΑΡΤΗΣ ΠΙΕΡΙΑΣ",
      fileUrl: "/2_EN-GR.pdf",
      fileName: "ΧΑΡΤΗΣ ΠΙΕΡΙΑΣ.pdf"
    },
    {
      id: 3,
      image: img3_GR,
      hoverText: "ΠΙΕΡΙΑ ΟΡΗ-ΤΟΥΡΙΣΤΙΚΟΣ ΟΔΗΓΟΣ",
      fileUrl: "/3_GR.pdf",
      fileName: "ΠΙΕΡΙΑ ΟΡΗ-ΤΟΥΡΙΣΤΙΚΟΣ ΟΔΗΓΟΣ.pdf"
    },
    {
      id: 4,
      image: img4,
      hoverText: "ΠΙΕΡΙΑ ΟΡΗ - ΧΑΡΤΗΣ",
      fileUrl: "/4_EN-GR.pdf",
      fileName: "ΠΙΕΡΙΑ ΟΡΗ - ΧΑΡΤΗΣ.pdf"
    },
    {
      id: 5,
      image: img5,
      hoverText: "ΤΑ ΠΡΟΣΚΥΝΗΜΑΤΑ ΤΗΣ ΠΙΕΡΙΑΣ",
      fileUrl: "/5_EN-GR.pdf",
      fileName: "ΤΑ ΠΡΟΣΚΥΝΗΜΑΤΑ ΤΗΣ ΠΙΕΡΙΑΣ.pdf"
    },
    {
      id: 6,
      image: img6,
      hoverText: "ΧΑΡΤΗΣ  ΠΡΟΣΚΥΝΗΜΑΤΩΝ  ΠΙΕΡΙΑΣ",
      fileUrl: "/6_EN-GR.pdf",
      fileName: "ΧΑΡΤΗΣ  ΠΡΟΣΚΥΝΗΜΑΤΩΝ  ΠΙΕΡΙΑΣ.pdf"
    },
    {
      id: 7,
      image: img7,
      hoverText: "ΑΡΧΑΙΟ ΔΙΟΝ ΓΙΑ ΠΑΙΔΙΑ",
      fileUrl: "/7_GR.pdf",
      fileName: "ΑΡΧΑΙΟ ΔΙΟΝ ΓΙΑ ΠΑΙΔΙΑ.pdf"
    },
    {
      id: 8,
      image: img8,
      hoverText: "ΠΙΕΡΙΑ, Η ΓΗ ΤΩΝ ΜΟΥΣΩΝ",
      fileUrl: "/8_GR.pdf",
      fileName: "ΠΙΕΡΙΑ, Η ΓΗ ΤΩΝ ΜΟΥΣΩΝ.pdf"
    }
  ];

  // DATA: English Section
  const englishFiles = [
    {
      id: 1,
      image: img1,
      hoverText: "Pieria Tourist Guide",
      fileUrl: "/1_EN-GR.pdf",
      fileName: "Pieria Tourist Guide.pdf"
    },
    {
      id: 2,
      image: img2,
      hoverText: "Map of Pieria",
      fileUrl: "/2_EN-GR.pdf",
      fileName: "Map of Pieria.pdf"
    },
    {
      id: 3,
      image: img3_EN,
      hoverText: "Pieria Mountains – Tourist Guide",
      fileUrl: "/3_EN.pdf",
      fileName: "Pieria Mountains – Tourist Guide.pdf"
    },
    {
      id: 4,
      image: img4,
      hoverText: "Pieria Mountains – Map",
      fileUrl: "/4_EN-GR.pdf",
      fileName: "Pieria Mountains – Map.pdf"
    },
    {
      id: 5,
      image: img5,
      hoverText: "The Pilgrimage Sites of Pieria",
      fileUrl: "/5_EN-GR.pdf",
      fileName: "The Pilgrimage Sites of Pieria.pdf"
    },
    {
      id: 6,
      image: img6,
      hoverText: "Map of Pieria’s Pilgrimage Sites",
      fileUrl: "/6_EN-GR.pdf",
      fileName: "Map of Pieria’s Pilgrimage Sites.pdf"
    },
    {
      id: 7,
      image: img7,
      hoverText: "Ancient Dion for Children",
      fileUrl: "/7_EN.pdf",
      fileName: "Ancient Dion for Children.pdf"
    },
    {
      id: 8,
      image: img8,
      hoverText: "PIERIA, THE LAND OF THE MUSES",
      fileUrl: "/8_EN.pdf",
      fileName: "PIERIA, THE LAND OF THE MUSES.pdf"
    }
  ];

  return (
    <div className="downloads-container">

  {selectedLanguage === "gr" ? (
    <>
      {/* Greek FIRST */}
      <div className="area-greek">
        <h2 className="section-title">{titles.gr.greek}</h2>
        <div className="files-grid">
          {greekFiles.map((item) => (
            <PdfDownloader
              key={item.id}
              imageSrc={item.image}
              hoverName={item.hoverText}
              fileUrl={item.fileUrl}
              fileName={item.fileName}
            />
          ))}
        </div>
      </div>

      {/* <hr className="divider" /> */}

      {/* English SECOND */}
      <div className="area-english">
        <h2 className="section-title">{titles.gr.english}</h2>
        <div className="files-grid">
          {englishFiles.map((item) => (
            <PdfDownloader
              key={item.id}
              imageSrc={item.image}
              hoverName={item.hoverText}
              fileUrl={item.fileUrl}
              fileName={item.fileName}
            />
          ))}
        </div>
      </div>
    </>
  ) : (
    <>
      {/* English FIRST */}
      <div className="area-english">
        <h2 className="section-title">{titles.en.english}</h2>
        <div className="files-grid">
          {englishFiles.map((item) => (
            <PdfDownloader
              key={item.id}
              imageSrc={item.image}
              hoverName={item.hoverText}
              fileUrl={item.fileUrl}
              fileName={item.fileName}
            />
          ))}
        </div>
      </div>

      {/* <hr className="divider" /> */}

      {/* Greek SECOND */}
      <div className="area-greek">
        <h2 className="section-title">{titles.en.greek}</h2>
        <div className="files-grid">
          {greekFiles.map((item) => (
            <PdfDownloader
              key={item.id}
              imageSrc={item.image}
              hoverName={item.hoverText}
              fileUrl={item.fileUrl}
              fileName={item.fileName}
            />
          ))}
        </div>
      </div>
    </>
  )}

</div>

    // <div className="downloads-container">
      
    //   {/*TOP AREA: GREEK*/}
    //   <div className="area-greek">
    //     <h2 className="section-title">Ελληνικά (Greek)</h2>
    //     <div className="files-grid">
    //       {greekFiles.map((item) => (
    //         <PdfDownloader
    //           key={item.id}
    //           imageSrc={item.image}
    //           hoverName={item.hoverText}
    //           fileUrl={item.fileUrl}
    //           fileName={item.fileName}
    //         />
    //       ))}
    //     </div>
    //   </div>

    //   <hr className="divider" />

    //   {/*BOTTOM AREA: ENGLISH*/}
    //   <div className="area-english">
    //     <h2 className="section-title">English</h2>
    //     <div className="files-grid">
    //       {englishFiles.map((item) => (
    //         <PdfDownloader
    //           key={item.id}
    //           imageSrc={item.image}
    //           hoverName={item.hoverText}
    //           fileUrl={item.fileUrl}
    //           fileName={item.fileName}
    //         />
    //       ))}
    //     </div>
    //   </div>

    // </div>
  );
};

export default DownloadsPage;